import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'henssler_at_home';
// const firebaseConfig = {
// 	kaisin: {
// 		apiKey: 'AIzaSyCCe20WPZ99icLGoleDNDxUmM7Bc4d6UwA',
// 		authDomain: 'kaisin-web-app.firebaseapp.com',
// 		projectId: 'kaisin-web-app',
// 		storageBucket: 'kaisin-web-app.firebasestorage.app',
// 		messagingSenderId: '223100500759',
// 		appId: '1:223100500759:web:de7aef42b526ab86015552',
// 		measurementId: 'G-VC6433FB74',
// 	},
// };
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: 'henssler@smoothr.de',
	// firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['de'],
	gaId: '',
	facebookPixelId: '268622425330452',
	hasRecommendations: true,
	apiUrl: 'https://dev-dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '6ad884f08f48681c45004618'
};

import 'zone.js';
